import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JobPreference } from '../../_models/machinaries/jobSetting';
import { environment } from '../../../../environments/environment';
import { MachineActivity } from '../../_models/machinaries/machineActivity';
import { MachineActivityToAutomach } from '../../_models/machinaries/machineActivityToAutomach';
import { JobSetting } from '../../_models/machinaries/jobSetting';

@Injectable()
export class MachineActivityService {
  private apiBaseUrl = environment.apiBaseUrl;
  private telemetryServiceUrl = environment.telemetryServiceUrl;

  constructor(private http: HttpClient) {}

  getMachineActivities(): Observable<MachineActivity[]> {
    const fieldActivityNull = true;
    return this.http
      .get<any>(
        this.apiBaseUrl + 'api/private/v1/machineActivity?fieldActivityNull=' + fieldActivityNull
      )
      .pipe(map((response) => response));
  }

  getMachineActivityToAutomaches(id: number): Observable<MachineActivityToAutomach> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/machineActivityToAutomaches/' + id)
      .pipe(map((response) => response));
  }

  getMachineActivity(id: number): Observable<any> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/machineActivity/' + id).pipe(
      map((response) => {
        return response;
      })
    );
  }

  saveMachineActivity(machineActivityItem): Observable<MachineActivity> {
    const machineActivity = { ...machineActivityItem };
    delete machineActivity.lastUpdated;
    delete machineActivity.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    machineActivity.companyId = companySelected ? companySelected.id : null;

    if (machineActivity.user != null && machineActivity.user.id != null) {
      machineActivity.user = { id: machineActivity.user.id };
    }
    if (machineActivity.id) {
      return this.http
        .put(
          this.apiBaseUrl + 'api/private/v1/machineActivity/' + machineActivity.id,
          machineActivity
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post(this.apiBaseUrl + 'api/private/v1/machineActivity', machineActivity)
        .pipe(map((response) => response));
    }
  }

  deleteMachineActivity(id: number): Observable<MachineActivity> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/machineActivity/' + id).pipe(
      map((response) => {
        return { id } as MachineActivity;
      })
    );
  }

  getJobSetting() {
    return this.http.get<any>(this.telemetryServiceUrl + 'api/private/v3/machine/settings').pipe(
      map((response) => {
        return response;
      })
    );
  }

  setJobSettingAutomatchDays(id, automatchDaysValue) {
    const body = new JobSetting();
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    body.companyId = companySelected ? companySelected.id : null;
    body.id = id;
    const preference = new JobPreference();
    preference.key = 'automatchDays';
    preference.value = automatchDaysValue;
    preference.type = 'INTEGER';
    body.preferences = [preference];
    if (id) {
      return this.http
        .put(this.telemetryServiceUrl + 'api/private/v3/machine/settings/' + id, body)
        .pipe(
          map((response) => {
            return response;
          })
        );
    } else {
      return this.http
        .post(this.telemetryServiceUrl + 'api/private/v3/machine/settings', body)
        .pipe(
          map((response) => {
            return response;
          })
        );
    }
  }
}
